// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__aGQyj","website":"styles_website__90R2Z","link":"styles_link__6ivDm"};